import { render, staticRenderFns } from "./BlogbookCatalog.vue?vue&type=template&id=0c7a0eb2&scoped=true&"
import script from "./BlogbookCatalog.vue?vue&type=script&lang=js&"
export * from "./BlogbookCatalog.vue?vue&type=script&lang=js&"
import style0 from "./BlogbookCatalog.vue?vue&type=style&index=0&id=0c7a0eb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7a0eb2",
  null
  
)

export default component.exports